<template>
  <div>
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>导航管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- //单行输入框 -->
    <div class="content">
        <el-form inline label-position="right" label-width="60px" size="small" class="query-form"  
         @submit.native.prevent="getList()"   >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList();">查询</el-button>
          <el-button type="success" @click="addList()">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
     <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>导航列表</span>
        </div>

          <el-table
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width:100%;"
        >
          <el-table-column prop="name" label="导航名称"></el-table-column>
          <!-- show-overflow-tooltip：可以修剪linkUrl的宽度 -->
          <el-table-column prop="linkUrl" label="链接地址" show-overflow-tooltip> 
              <template slot-scope="scope" >
               <a :href="scope.row.linkUrl" target="_blank" class="buttonText">{{scope.row.linkUrl}}</a>
              </template>
          </el-table-column>
          <el-table-column prop="sort" label="排序编号"></el-table-column>
          <el-table-column prop="createTime" label="创建时间"></el-table-column>
           <el-table-column label="操作">
            <template slot-scope="scope">
              <el-tooltip  content="编辑" placement="top">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  @click="editClick(scope.row)"
                ></el-button>
              </el-tooltip>
              <el-tooltip  content="删除" placement="top">
                <el-button
                  type="warning"
                  size="mini"
                  icon="el-icon-delete"
                  @click="delClick(scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>

        </el-table>
        <!-- 分页条 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50,100]"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
      <!-- 对话框 -->
         <el-dialog
      :title="form.id>0?'编辑导航':'添加导航'"
      :visible.sync="dialogVisible"
    
    >
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm('form')"
      >
        <el-form-item
          label="导航名称"
          prop="name"
          :rules="[{required:true,message:'请输入导航名,最多10个字'}]"
        >
          <el-input v-model="form.name" placeholder="请输入导航名"></el-input>

        </el-form-item>
     

         <el-form-item
          label="链接地址"
          prop="linkUrl"
          :rules="[  {required:true,message:'链接不能为空'}]"
        >
        <!-- {type:'url',message:'请输入正确的链接',trigger:'blur'} -->
          <el-input v-model="form.linkUrl" placeholder="请输入链接地址"></el-input>
        </el-form-item>
        
         <el-form-item
          label="排序编号"
          prop="sort"
            :rules="[{required:true,message:'请输入排序编号,最多10个字'}]"
        >
          <el-input type="number" v-model.number="form.sort" placeholder="请输入排序编号"></el-input>
        </el-form-item>
                   <el-form-item
          label="简介"
          prop="summary"
        >
          <el-input v-model="form.summary" placeholder="请输入简介"></el-input>
        </el-form-item>
               <el-form-item
          label="seo标题"
          prop="seo_Title"
        >
          <el-input v-model.number="form.seo_Title" placeholder="请输入seo标题"></el-input>
        </el-form-item>
                 <el-form-item
          label="seo关键字"
          prop="seo_Keywords"
        >
          <el-input v-model.number="form.seo_Keywords" placeholder="请输入seo关键字"></el-input>
        </el-form-item>
                 <el-form-item
          label="seo描述"
          prop="seo_Description"
        >
          <el-input v-model.number="form.seo_Description" placeholder="请输入seo描述"></el-input>
        </el-form-item>


        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    


  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
data() {
    return {
      //  key: "",
      query: {}, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      dialogVisible: false,
      submiting: false,
      id: 0,
    }
},
created() {      
    this.getList();
  },
methods: {
  addList(){
    // this.$refs['from'].resetFields();
      this.dialogVisible = true;
      this.form={};
      
  },
        handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    getList: function() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      // params.key = _this.key;
      var link = url.getGroup("GetNavList");
      $.get(link, params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
        // console.log(data)
        //控制弹出框为添加
        this.form.id={}
      });
    },
      //编辑
    editClick: function(row) {
      this.form = Object.assign({}, row);
      this.dialogVisible = true;
    },
    //删除
    delClick: function(row) {
      var _this = this;
      var link = url.getGroup("DelectNav_Info"); //获取请求地址
      var id = row.id; //获取对象id
      this.$confirm("确定要删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $.post(link,  {id:id} , res => {
            _this.btnLoading = false;
              if (res.status) {
                  _this.msg = res;
                  _this.getList();
                  this.$message({
                      type: "success",
                      message: "删除成功!"
                  });
              } else {
                  this.$message({
                      type: "error",
                      message: res.msg
                  });
              }
          });
     
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
      submitForm(formName) {
      var _this = this;
      var link = url.getGroup("Save_Nav");
      var info = this.form;
      console.log(info)
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submiting = true;
          //提交后台添加
          //添加或者修改
          $.post(link, info, res => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
    
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        } else {
          return false;
        }
      });
    },

},

}
</script>

